export enum AccountRegisterSubTypeEnum {
    trialPublisher90d ,
    trialPublisher100x
}
